import styled from 'styled-components';
import { themeGet, variant } from 'styled-system';
import { Box, Button, Flex, Text } from '../ui-kit';
import CloseIcon from '../ui-kit/icons/Close';
import theme from '../ui-kit/themes/theme';

export const CloseButton = styled(Button)`
  color: unset;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 0;
  align-self: flex-start;
  min-height: 16px;
  min-width: 16px;

  :focus {
    border: none;
  }
  :active {
    border: none;
  }
`;

export const ActionButton = styled(Button)`
  margin-top: ${themeGet('space.3')}px;
  padding: 0px;
  font-size: ${themeGet('fontSizes.9')}px;
  border: 2px solid ${themeGet('colors.preciousStoneBlue.100')};
  background-color: transparent;
  color: ${themeGet('colors.preciousStoneBlue.100')};
  width: fit-content;
  padding: 6px ${themeGet('space.2')}px;
  letter-spacing: normal;
  line-height: 1;
  transition: filter 0.2s;

  :hover {
    border: 2px solid ${themeGet('colors.preciousStoneBlue.100')};
    filter: opacity(0.7);
  }
`;

export const AlertIcon = styled(Box)`
  display: flex;
  height: 20px;
  margin-right: 10px;
  align-items: center;
  svg {
    color: ${props => (props.variant === 'success' ? themeGet('colors.successGreen') : '')};
  }
`;

export const AlertContent = styled(Flex)`
  flex-direction: column;
  width: 100%;
  margin-top: 3px;
`;

export const AlertDescription = styled(Text)`
  font-weight: ${theme.fontWeights.medium};
  font-size: ${theme.fontSizes[0]}px;
  line-height: 18px;
  color: ${themeGet('colors.nightSkyBlack.80')};
`;

export const AlertCloseIcon = styled(CloseIcon)`
  cursor: pointer;
`;

export const AlertTitle = styled(Text)`
  line-height: 16px;
  font-size: ${themeGet('fontSizes.9')}px;
  margin-bottom: 5px;
  font-weight: bold;
`;

const alertStyle = variant({
  key: 'alerts'
});

export const AlertWrapper = styled(Flex)`
  ${alertStyle}
  display: flex;
  border-radius: 10px;
  position: relative;
  padding: 12px 16px;
  background-color: ${props => (props.variant === 'success' ? themeGet('colors.deepForestGreen.10') : '')};
  background-color: ${props =>
    props.variant === 'warning' && props.abTest ? themeGet('colors.woodpeckerRed.20') : ''};
  width: ${props => props.width || (props.abTest && !props.isHorizontal && '100%')};
  font-size: ${props => props.fontSize}px;
`;

export const Icon = styled.img`
  width: 16px;
  height: 16px;
`;
